import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  createDocumentMock,
  documentExpertCategoriesMock,
  documentExpertDetailsMock,
  documentsExpertListMock,
  successMock,
  getCommentListMock,
  commentSuccessMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { documentPath } from '../../utils/paths';

export default {
  documentsExpertListGet: ({ filters }) => {
    if (shouldUseMock()) {
      return documentsExpertListMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  documentExpertDetailsGet: ({ id }) => {
    if (shouldUseMock()) {
      return documentExpertDetailsMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/${id}/details`,
      'GET'
    );
  },
  documentExpertCategoriesGet: (param) => {
    if (shouldUseMock()) {
      return documentExpertCategoriesMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/category/list${parseQueryParams(
        param
      )}`,
      'GET'
    );
  },
  documentExpertDocumentCreate: (body) => {
    if (shouldUseMock()) {
      return createDocumentMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/create`,
      'POST',
      body
    );
  },
  documentExpertDocumentDelete: (id, published) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/${id}/delete`,
      'POST',
      { published }
    );
  },
  documentExpertDocumentUpload: ({ id }) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/${id}/document/upload`,
      'POST'
    );
  },
  documentExpertCoverUpload: ({ id }) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/${id}/cover/upload`,
      'POST'
    );
  },
  documentExpertSetComment: ({ body, id }) => {
    if (shouldUseMock()) {
      return commentSuccessMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/${id}/comment`,
      'POST',
      body
    );
  },
  documentExpertSetCommentReply: ({ body, id, cid }) => {
    if (shouldUseMock()) {
      return commentSuccessMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/${id}/comment/${cid}/reply`,
      'POST',
      body
    );
  },
  documentExpertGetCommentList: (id) => {
    if (shouldUseMock()) {
      return getCommentListMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents_for_experts/${id}/comment/list`,
      'GET'
    );
  },
};
